import { jsx as _jsx } from "react/jsx-runtime";
import Grid from "@mui/material/Grid2";
import { LayoutCell } from "./LayoutCell";
import { useLayoutGridContainerComputedProps } from "./useLayoutGridContainerComputedProps";
import { useLayoutGridItemComputedProps } from "./useLayoutGridItemComputedProps";
/**
 * Renders flexbox layout grid (layout rows, columns)
 * @param props
 * @returns
 */
export function LayoutFlexboxGrid(props) {
    const { node } = props;
    const { cells } = node;
    const { rowSpacing, columnSpacing, columns, sx } = useLayoutGridContainerComputedProps(props);
    const getItemProps = useLayoutGridItemComputedProps();
    return (_jsx(Grid, { className: `LayoutGrid-${node.id}`, container: true, rowSpacing: rowSpacing, columnSpacing: columnSpacing, columns: columns, sx: sx, children: cells.map((cell) => (_jsx(LayoutFlexboxGridItem, Object.assign({}, getItemProps({ cell }), { children: _jsx(LayoutCell, { node: cell }) }), cell.id))) }));
}
// compatibility export
export { LayoutFlexboxGrid as LegacyLayoutGrid };
export function LayoutFlexboxGridItem(props) {
    const { size, sizes, sx, className, children } = props;
    return (_jsx(Grid, { className: className, sx: sx, size: sizes !== null && sizes !== void 0 ? sizes : { sm: size }, children: children }));
}
//# sourceMappingURL=LayoutFlexboxGrid.js.map